import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  templateUrl: 'textarea.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class TextAreaFieldTypeComponent extends FieldType {
}
